import { SectionPanel } from '../../shared/ui/section-panel';
import { ErrorState, LoadingState } from '../../shared/ui/states';
import { periodLabel, useStorageLevels } from '../../entities/retention';
import { BiggestFlows } from './biggest-flows';
import { ExceptionsList } from './exceptions-list';
import { FolderTable } from './folder-table';
import { LevelCards } from './level-cards';

const MANY_FOLDERS = 7;

interface IRetentionLevelsProps {
  now: number;
  biggestId: string;
}

/** Board S1, "How long it's kept": the three levels, never a table of every flow. */
export const RetentionLevels = ({ now, biggestId }: IRetentionLevelsProps) => {
  const levels = useStorageLevels();

  if (levels.isError) {
    return <ErrorState error={levels.error} onRetry={() => void levels.refetch()} />;
  }
  if (levels.isPending) return <LoadingState rows={8} />;
  const data = levels.data;
  const many = data.folders.length > MANY_FOLDERS;

  return (
    <SectionPanel
      title="How long it’s kept"
      note={
        many
          ? `default ${periodLabel(data.defaultPeriod)} · ${data.folders.length} folders · ${data.exceptionCount} exceptions`
          : 'set at three levels — the most specific wins'
      }
    >
      <div className="pt-4">
        <LevelCards levels={data} now={now} />
        {(data.folders.length > 0 || data.older.bytes > 0) && (
          <div className="border-t border-border-sunken">
            <FolderTable levels={data} />
          </div>
        )}
        <ExceptionsList total={data.exceptionCount} />
        <BiggestFlows levels={data} id={biggestId} />
      </div>
    </SectionPanel>
  );
};
